import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import AuthService from '../services/authService';

class Logout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loggedOut: false,
        }
    }

    componentDidMount() {
        AuthService.logout();
        this.setState({loggedOut: true})
    }

    render() {
        if (this.state.loggedOut) {
            return <Redirect to="/" />
        } 
        else {
            return <p>Logging out...</p>
        }
    }
}

export default Logout;
